module.exports = __webpack_public_path__ + "static/media/Settings.3215dfff.svg";